<template>
	<v-card flat color="secondary">
		<v-card-text>
			<emb-perfect-scrollbar class="scroll-area" style="height: 70vh;">
				<v-row dense>
					<v-col
						cols="12"
						xl="1"
						lg="2"
						md="2"
						sm="3"
						class="mb-0"
						v-for="(table, i) in tables"
						:key="i"
					>
						<v-card
							:color="
								!table.free
									? table.printed_pre_account
										? 'primary lighten-3'
										: 'accent lighten-1'
									: 'success'
							"
							hover
							dark
						>
							<el-tooltip
								class="item"
								effect="dark"
								content="Imprimir Pre-Cuenta"
								placement="top"
							>
								<i
									v-if="table.command_id"
									class="el-icon-printer float-left ma-3"
									@click.prevent="
										clickPrintPreAccount(table.command_id)
									"
								>
								</i>
							</el-tooltip>
							<el-tooltip
								class="item"
								effect="dark"
								content="Cancelar pedido"
								placement="top"
							>
								<i
									v-if="table.command_id"
									class="el-icon-delete float-right ma-3"
									@click.prevent="
										clickCancelCommand(table.command_id)
									"
								>
								</i>
							</el-tooltip>
							<div @click.prevent="clickAddCommand(table.id, table.command_id)">
								<h6 class="text-center white--text py-2">{{ table.name }}</h6>
								<h5 class="text-center">
									<v-chip color="dark" text-color="white" small>
										{{ table.free ? 'VACÍO' : table.total }}
									</v-chip>
								</h5>
								<p class="text-center caption white--text mb-0">Mozo: {{ table.waiter }}</p>
								<p class="text-center caption white--text mb-0 pb-2" v-if="table.command_id">
									<v-icon>mdi-timer</v-icon> {{ getElapsedTime(table.created_at) }}
								</p>
                <p class="text-center caption white--text mb-0 pb-2" v-else>
                  <v-icon>mdi-timer</v-icon>
                </p>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</emb-perfect-scrollbar>
			<v-row>
				<v-chip
					x-small
					class="mt-2 mr-1"
					color="success"
					label
					text-color="white"
				>
					Mesa libre
				</v-chip>
				<v-chip x-small class="mt-2 mx-1" color="accent lighten-1" label text-color="white">
					Mesa ocupada
				</v-chip>
				<v-chip
					x-small
					class="mt-2 mx-1"
					color="primary lighten-3"
					label
					text-color="white"
				>
					Pre-Cuenta impresa
				</v-chip>

				<v-spacer></v-spacer>

				<v-chip
					x-small
					class="mt-2 mx-1"
					color="accent"
					label
					text-color="white"
					v-for="(salon, index) in salons"
					@click.prevent="getTablesBySalon(salon.id)"
					:key="index"
					:outlined="currentSalonID === salon.id ? false : true"
				>
					{{ salon.name }}
				</v-chip>
			</v-row>
			<!-- <v-tabs fixed-tabs centered background-color="primary" dark class="rounded">
				<v-tab
					v-for="(salon, index) in salons"
					@click.prevent="getTablesBySalon(salon.id)"
					:key="index"
				>
					{{ salon.name }}
				</v-tab>
			</v-tabs> -->
		</v-card-text>
	</v-card>
</template>

<script>
import { deletable } from 'Mixins/deletable';
import { confirm } from 'Mixins/confirm';

export default {
	mixins: [deletable, confirm],
	data() {
		return {
			resource: 'commands',
      echoServer: window.Echo,
      ordersChannel: null,
			salons: [],
			tables: [],
			tab: null,
			currentSalonID: null,
      loadingTables: false,
      timerInterval: null,
      now: Date.now(),
		};
	},
	async created() {
      await this.getTables();
	},
	mounted: function() {
    this.ordersChannel = this.echoServer.private('orders');
    this.ordersChannel.listen('getOrdersEvent', this.handleOrdersEvent)

    this.timerInterval = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  beforeDestroy() {
    if (this.ordersChannel) {
      this.ordersChannel.stopListening('getOrdersEvent', this.handleOrdersEvent);
    }

    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
	methods: {
    getElapsedTime(createdAt) {
      const diff = Math.floor((this.now - new Date(createdAt).getTime()) / 1000);
      const d = Math.floor(diff / 86400);
      const h = Math.floor((diff % 86400) / 3600);
      const m = Math.floor((diff % 3600) / 60);
      const s = diff % 60;
      let result = '';
      if (d > 0) result += `${d}d `;
      if (h > 0 || d > 0) result += `${h}h `;
      if (m > 0 || h > 0 || d > 0) result += `${m}m `;
      result += `${s}s`;
      return result.trim();
    },
    handleOrdersEvent() {
      this.getTablesBySalon(this.currentSalonID);
    },
		getTables() {
			this.$http.get(`/${this.resource}/salons`).then((response) => {

				this.salons = response.data;

				if (this.salons.length > 0) {
					if (localStorage.getItem('salonID') !== null) {
						
						this.getTablesBySalon(localStorage.getItem('salonID'));
						this.currentSalonID = localStorage.getItem('salonID');
					} else {
						this.getTablesBySalon(this.salons[0].id);
						this.currentSalonID = this.salons[0].id;
						localStorage.setItem('salonID', this.salons[0].id)
					}
					// localStorage.setItem('salons', JSON.stringify(this.salons));
				}
			});
		},
		getTablesBySalon(salonId) {
			this.currentSalonID = salonId;
			this.$http.get(`/${this.resource}/tables/by-salon/${salonId}`).then((response) => {
				this.tables = response.data;
				localStorage.setItem('salonID', this.currentSalonID);
			});
		},
		clickAddCommand(tableId, commandID) {
			this.$router.push({ name: 'SaleAdd', params: { id: tableId, command_id: commandID } });
		},
		clickCancelCommand(id) {

                this.$alert('¿Desea cancelar el pedido?', 'Cancelar', {
                    confirmButtonText: 'Cancelar pedido',
                    cancelButtonText: 'Cerrar',
                    type: 'warning'
                }).then(() => {
                    this.$http.delete(`/${this.resource}/cancelled/${id}`)
                        .then(resp => {
                          if (resp.data.success) {
                            this.$message.success('El pedido fue cancelado satisfactoriamente');
                          } else {
                            this.$message.error(resp.data.message);
                          }
                        })
                        .catch(error => {
                            if (error.response.status === 500) {
                                this.$message.error('Error al intentar cancelar el pedido.');
                            } else if(error.response.status === 403) {
                                this.$message.error('No posee permisos para realizar esta acción.');
                            } else {
                                console.log(error.response.data.message)
                            }
                        })
                }).catch(error => {
                    console.log(error)
                });
		},
		verifyIP(PC_IP) {
			const controller = new AbortController();
			const timeoutId = setTimeout(() => controller.abort(), 1300);

			return fetch(`https://${PC_IP}/print-api/`, { signal: controller.signal }).then(function () {
				clearTimeout(timeoutId);
                return true;
            }, function () {
				clearTimeout(timeoutId);
                return false;
            });
		},
		async clickPrintPreAccount(id) {
			await this.$http.get(`/${this.resource}/print/pre-account/${id}`).then((resp) => {
				if (resp.data.success) {
					this.printOrder(resp.data.data)
				} else {
					this.$message.error(resp.data.message);
				}
			});
		},
		async printOrder(result) {
			// const config = result.config
			let data = JSON.stringify(result)

			// const PC_IP = config.pc_ip
			// const EST_ID = config.establishment_id
			// let IP_ALT = '192.168.1.200'

			// if (EST_ID == 2)
			// 	IP_ALT = '192.168.1.20'

			// const available = await this.verifyIP(PC_IP)

			// if (available) {
			// 	this.execPrint(data, PC_IP)
			// } else {
			// 	const availableAlt = await this.verifyIP(IP_ALT)
			// 	if (availableAlt) {
			// 		this.execPrint(data, IP_ALT)
			// 	} else {
			// 		this.$message.error('Error! No se pudo establecer conexión')
			// 	}
			// }

			this.execPrint(data)
		}, 
		execPrint(data) {
			// let url = `https://${PC_IP}/print-api/print/pre-account`;
			let url = `https://192.168.1.200/print-api/print/pre-account`;

			fetch(url, { method: 'POST', body: data })
				.then((dataWrapped) => dataWrapped.json())
				.then((data) => {
					if (data.success) {
						this.$message.success(data.message)
					} else {
						this.$message.error(data.message)
					}
				})
				.catch((error) => {
					console.error('Error: ', error)
				});
		}
	},
};
</script>
